import * as React from "react"
import { Badge } from "gatsby-interface"
const defaultFilter = () => true

function Label({ label, isNew = false }) {
  return (
    <React.Fragment>
      {label}{" "}
      {isNew && (
        <Badge size="S" tone="SUCCESS">
          New
        </Badge>
      )}
    </React.Fragment>
  )
}

export default function getSideNavOptions({
  sections,
  sectionLabels,
  getLink,
  location,
  filterWith = defaultFilter,
}) {
  return sections
    .filter(({ id }) => filterWith(id))
    .reduce(
      (memo, { id, Icon, subsections, isNew }) => {
        const to = getLink(id)

        const active = location.pathname.includes(to)
        const subItems =
          subsections &&
          subsections
            .filter(({ id }) => filterWith(id, { isSubsection: true }))
            .map(({ id: subsectionId, isNew }) => {
              const idSelector = `#${subsectionId}`
              return {
                name: subsectionId,
                label: (
                  <Label label={sectionLabels[subsectionId]} isNew={isNew} />
                ),
                active: location.hash.includes(idSelector),
                to: `${to}${idSelector}`,
              }
            })

        const sectionInfo = {
          name: id,
          label: <Label label={sectionLabels[id]} isNew={isNew} />,
          to,
          active,
        }

        return {
          sidebarNavOptions: [
            ...memo.sidebarNavOptions,
            {
              ...sectionInfo,
              Icon,
              subItems,
            },
          ],
          sections: [
            ...memo.sections,
            {
              ...sectionInfo,
              subsections: subItems,
            },
          ],
        }
      },
      { sections: [], sidebarNavOptions: [] }
    )
}
